import React, { useEffect } from "react"
import { Route, Switch, Redirect, useLocation } from "react-router-dom"
import CreateProject from "../views/projectModule/CreateProject"
import ProjectHistory from "../views/projectModule/ProjectHistory"
import ProjectListing from "../views/projectModule/ProjectListing"
import UpdateProject from "../views/projectModule/UpdateProject"
import ProjectDetails from "../views/projectModule/ProjectDetails"
import CMAssignedTickets from "../views/ticketModule/cmrole/CMAssignedTickets"
import CMTicketApproval from "../views/ticketModule/cmrole/CMTicketApproval"
import CountryManagerTicketListing from "../views/ticketModule/cmrole/CountryManagerTicketListing"
import DepartmentTicketListing from "../views/ticketModule/deptrole/DepartmentTicketListing"
import DeptTicketApproval from "../views/ticketModule/deptrole/DeptTicketApproval"
import EditTicketByResource from "../views/ticketModule/resourcerole/EditTicketByResource"
import MyTickets from "../views/ticketModule/resourcerole/MyTickets"
import Ticket from "../views/ticketModule/resourcerole/Ticket"
import TicketDetails from "../views/ticketModule/cmrole/TicketDetails"
import WeeklyView from "../views/timesheetModule/WeeklyView"
import MyDashboard from "../views/Dashboard/MyDashboard"
import SpDashboard from "../views/Dashboard/SpDashboard"
import CMDashboard from "../views/Dashboard/CMDashboard"
import SpTimesheet from "../views/timesheetModule/SpTimesheet"
import SignIn from "../SignIn"
import EditFeedback from "../views/Feedbacks/EditFeedback"
import FeedbackList from "../views/Feedbacks/FeedbackList"
import FeedbackView from "../views/Feedbacks/FeedbackView"
import FeedbackDetails from "../views/Feedbacks/FeedbackDetails"
import IFrameFile from "../components/IFrameFile"
import ManageLeavesView from "../views/leaveManagement/manageLeaves/ManageLeavesView"
import Leavelayout from "../views/leaveManagement/createLeave/Leavelayout"
import OfficeHours from "../views/MyOfficeHours/OfficeHours"
import MyReimbursement from "../views/MyReimbursement/MyReimbursements"
import MonthlyReimbursement from "../views/MyReimbursement/CreateReimbursement/MonthlyReimbursement"
import MyTimeSheetsStatusView from "../views/myTimeSheetsStatus/MyTimeSheetsStatusView"
import OffsiteWorkHours from "../views/OffsiteWorkHours/OffsiteWorkHours"
import ExportAttendance from "../views/adminRole/ExportAttendance/OfficeHours"
import UpdateAttendance from "../views/adminRole/UpdateAttendance/SpTimesheet"
import AddEmployee from "../views/adminRole/AddEmployee/ModifyEmployee"
import ViewLeaveApplication from "../views/adminRole/ViewLeaves/ViewLeaveApplication"
import lateNotification from "../views/Settings/lateNotifications/lateNotifications"
import CheckInCheckOut from "../views/SpRole_CheckInCheckOut/CheckInCheckOut"
import CreateGeneralReimbursement from "../views/MyReimbursement/CreateReimbursement/CreateGeneralReimbursement/CreateGeneralReimbursement"
import OffsiteHoursRequestForm from "../views/OffsiteWorkHours/createOffsiteWorkHours/OffsiteHoursRequestForm"
import SpOffsiteWorkHours from "../views/SupervisorRole/spOffsiteWorkHours/SpOffsiteWorkHours"
import ItemRequisitionLayout from "../views/ItemRequisition/ItemRequisitionLayout"
import CreateItemRequisitionLayout from "../views/ItemRequisition/createItemRequisition/CreateItemRequisitionLayout"
import ResourceProjectHours from "../views/SpRole/SpRoleResourcePHours/ResourceProjectHours"
import ReviewLeaveApplication from "../views/SupervisorRole/ReviewLeaveApplication/ReviewLeaveApplication"
import ReviewLeaveApplicationDetail from "../views/SupervisorRole/ReviewLeaveApplication/ReviewLeaveApplicationDetail"
import ReviewedLeaveApplication from "../views/SupervisorRole/ReviewedLeaveApplication/ReviewedLeaveApplication"
import ReviewedLeaveApplicationDetail from "../views/SupervisorRole/ReviewedLeaveApplication/ReviewedLeaveApplicationDetail"
import ReviewItemRequsition from "../views/SupervisorRole/ReviewItemRequsition/ReviewItemRequsition"
import ReviewItemRequisitionDetail from "../views/SupervisorRole/ReviewItemRequsition/ReviewItemRequisitionDetail"
import SpResourceLeavesInfo from "../views/SupervisorRole/ResourceLeavesInfo/SpResourceLeavesInfo"
import viewEmployees from "../views/SupervisorRole/ViewEmployees/ViewEmployees"
import ModifyEmployee from "../views/SupervisorRole/ViewEmployees/ModifyEmployee/ModifyEmployee"
import ManageOffsiteWorkRequest from "../views/SupervisorRole/spOffsiteWorkHours/manageOffsiteWorkRequest/ManageOffsiteWorkRequest"
import SpMonthlyTimesheet from "../views/SupervisorRole/MonthlyTimesheets/MonthlyTimesheet"
import Calculator from "../views/MyReimbursement/Calculator/Calculator"
import ResourceDailyHours from "../views/SpRole/SpRole_Resource_Daily_hours/ResourceDailyHours"
import TotalProjectHours from "../views/SpRole/SpRole_total_Project_hours/TotalProjectHours"
import SpTimesheetStatus from "../views/SpRole_TimesheetStatus/SpTimesheetStatus"
import CalendarHolidays from "../views/CalendarHolidays/CalendarHolidays"
import SSNItemRequisitionDetail from "../views/ItemRequisition/SSN/SSNItemRequisitionDetail"
import SSNCreateItemRequisition from "../views/ItemRequisition/SSN/SSNCreateItemRequisition"
import AdminCalendarHolidays from "../views/adminRole/CalendarHolidays/CalendarHolidays"
import AddNewHoliday from "../views/adminRole/CalendarHolidays/CreateNew/AddNewHoliday"
import ItemRequisitionClasses from "../views/SupervisorRole/ReviewItemRequsition/SSN/ItemRequisitionClass"
import ItemRequisitionVendors from "../views/SupervisorRole/ReviewItemRequsition/SSN/ItemRequisitionVendor"
import ItemRequisitionCategories from "../views/SupervisorRole/ReviewItemRequsition/SSN/ItemRequisitionCategory"
import CreateNewVendor from "../views/SupervisorRole/ReviewItemRequsition/SSN/CreateNew/CreateNewVendors"
import VendorCategories from "../views/SupervisorRole/ReviewItemRequsition/SSN/VendorCategories"
import VendorContact from "../views/SupervisorRole/ReviewItemRequsition/SSN/VendorContact"
import ReimbursementPolicy from "../views/FinanceRole/ReimbursementsPolicies/ReimbursementPolicy"

import ReimbursementPolicyUpload from "../views/FinanceRole/ReimbursementsPolicies/ReimbursementPolicyUpload"

import MonthlyConfigForm from "../views/adminRole/MonthlyTimesheetsConfig/MonthlyConfigForm"
import ViewLeaveApplicationDetail from "../views/adminRole/ViewLeaves/ViewLeaveApplicationDetail"
import EmployeeWorkStatus from "../views/adminRole/EmployeeWorkStatus/EmployeeWorkStatus"
import AddEmployeeWorkStatusForm from "../views/adminRole/EmployeeWorkStatus/AddEmployeeWorkStatusForm"
import CompensationLog from "../views/adminRole/CompensationLog/CompensationLog"
import CompensationLogDetail from "../views/adminRole/CompensationLog/CompensationLogDetail"
import ResourceLeavesInfo from "../views/SupervisorRole/ResourceLeavesInfo/ResourceLeavesInfo"
import AdminViewResourceLeavesInfo from "../views/SupervisorRole/ResourceLeavesInfo/AdminViewResourceLeavesInfo"
import MyProfile from "../views/MyProfile/MyProfile"
import EditProfile from "../views/MyProfile/EditProfile"
import ProjectReport from "../views/SupervisorRole/ProjectReport/ProjectReport"
import ManageLeaves from "../views/employeeLeave/ManageLeaves"
import EmployeeLeaveInfoListing from "../views/SupervisorRole/ResourceLeavesInfo/EmployeeLeaveInfoListing"
import EmployeesMonthlyLeaves from "../views/SupervisorRole/EmployeesMonthlyLeaves/EmployeesMonthlyLeaves"
import TicketHistory from "../views/ticketModule/deptrole/TicketHistory"
import TimesheetPerformanceReport from "../views/SupervisorRole/TimesheetPerformanceReport/TimesheetPerformanceReport"
import { Designation } from "../views/adminRole/CreateDesignation/Designation"

const titleMap = [
	{ path: "/", title: "Dashboard" },
	{ path: "/MyDashboard", title: "My Dashboard" },
	{ path: "/SpDashboard", title: "Supervisor Dashboard" },
	{ path: "/CMDashboard", title: "CM Dashboard" },
	//Employee
	{ path: "/ManageLeavesView", title: "My Leaves" },
	{ path: "/OffsiteWorkHours", title: "My Offsite Hours" },
	{ path: "/MyOfficeHours", title: "My Office Hours" },
	{ path: "/MyReimbursement", title: "My Reimbursement" },
	{ path: "/ItemRequisition", title: "Item Requisition" },
	{ path: "/MyTickets", title: "My Tickets" },
	{ path: "/DepartmentTicketListing", title: "Resource Tickets" },
	{ path: "/WeeklyView", title: "My Timesheet" },
	{ path: "/MyTimeSheetStatus", title: "My Timesheet Status" },
	{ path: "/Bug", title: "Report a Bug" },
	{ path: "/ReportedBugs", title: "Reported Bugs" },
	{ path: "/CalendarHolidays", title: "Calendar Holidays" },
	{ path: "/ReportedBugs", title: "Reported Bugs" },
	//Supervisor
	{ path: "/SpTimesheet", title: "Employee Timesheet" },
	{ path: "/SpTimeSheetStatus", title: "Employee Timesheet Status" },
	{ path: "/SpReviewLeave", title: "Review Leave Applications" },
	{ path: "/SpReviewedLeave", title: "Reviewed Leave Applications" },
	{
		path: "/ReviewItemRequsition",
		title: "Review Item Requisition Requests",
	},
	{ path: "/spOffsiteWorkHours", title: "Offsite Work Request" },
	{ path: "/CheckInCheckOut", title: "Extract Checkin Checkout" },
	{ path: "/SpMonthlyTimesheet", title: "Monthly Timesheets" },
	{ path: "/EmployeeLeavesListing", title: "Employees Leaves Info" },
	{ path: "/EmployeesMonthlyLeaves", title: "Employees Monthly Leaves" },
	{ path: "/totalProjectHours", title: "Total Project Hours" },
	{ path: "/ResourceProjectHours", title: "Resource Project Hours" },
	{ path: "/resourceDailyHours", title: "Resource Daily Hours" },
	{ path: "/ProjectReport", title: "Project Report" },
	{ path: "/ProjectListing", title: "All Projects" },
	{ path: "/ViewEmployees", title: "View Employees" },
	{ path: "/CountryManagerTicketListing", title: "CM Tickets" },
	{ path: "/CMAssignedTickets", title: "CM Tickets" },

	//Admin
	{ path: "/adminRole/CompensationLog", title: "Compensation Log" },
	{ path: "/adminRole/ExportAttendance", title: "Export Attendance" },
	{ path: "/adminRole/EmployeeWorkStatus", title: "Employee Work Status" },
	{
		path: "/adminRole/UpdateAttendance",
		title: "Employee Attendance Update",
	},
	{ path: "/adminRole/AddEmployee", title: "Add Employee" },
	{ path: "/adminRole/ViewLeaves", title: "View Leaves Applications" },
	{ path: "/MonthlyTimesheetsConfig", title: "Monthly Timesheet Config" },
	{ path: "/Settings/lateNotifications", title: "Late Notification" },
	{ path: "/AdminCalendarHolidays", title: "Admin Calendar Holidays" },
]
let Routes = ({ userDetails }) => {
	let history = useLocation()
	useEffect(() => {
		let title = history.pathname
		const curTitle = titleMap.find((item) => item.path === title)
		if (curTitle && curTitle.title) {
			document.title = curTitle.title
		}
	})

	return (
		<Switch>
			<Route path="/MyProfile" exact component={MyProfile} />
			<Route path="/EditProfile" exact component={EditProfile} />
			<Route
				path="/ManageLeavesView"
				exact
				component={ManageLeavesView}
				title="My Leaves"
			/>
			<Route path="/CreateLeave" exact component={Leavelayout} />
			<Route path="/LeaveDetail/:id" exact component={Leavelayout} />
			<Route
				path="/CalendarHolidays"
				exact
				component={CalendarHolidays}
			/>
			<Route path="/MyOfficeHours" exact component={OfficeHours} />
			<Route path="/MyOfficeHours/:id" exact component={OfficeHours} />
			<Route path="/Calculator" exact component={Calculator} />
			<Route path="/MyReimbursement" exact component={MyReimbursement} />
			<Route
				path="/monthlyReimbursement"
				exact
				component={MonthlyReimbursement}
			/>
			<Route
				path="/monthlyReimbursement/:id"
				exact
				component={MonthlyReimbursement}
			/>
			<Route
				path="/generalReimbursement/:id"
				exact
				component={CreateGeneralReimbursement}
			/>
			<Route
				path="/generalReimbursement"
				exact
				component={CreateGeneralReimbursement}
			/>

			<Route
				path="/OffsiteWorkHours"
				exact
				component={OffsiteWorkHours}
			/>
			<Route
				path="/OffsiteWorkHours/:id"
				exact
				component={OffsiteHoursRequestForm}
			/>
			<Route
				path="/OffsiteWorkHoursRequest"
				exact
				component={OffsiteHoursRequestForm}
			/>

			<Route path="/MyOfficeHours" exact component={OfficeHours} />
			<Route
				path="/adminRole/ExportAttendance"
				exact
				component={ExportAttendance}
			/>
			<Route
				path="/adminRole/UpdateAttendance"
				exact
				component={UpdateAttendance}
			/>
			<Route
				path="/adminRole/AddEmployee"
				exact
				component={AddEmployee}
			/>
			<Route
				path="/adminRole/ViewLeaves"
				exact
				component={ViewLeaveApplication}
			/>
			<Route
				path="/adminRole/ViewLeaveApplicationDetail/:id"
				exact
				component={ViewLeaveApplicationDetail}
			/>

			{/* Settings Menu */}
			<Route
				path="/Settings/lateNotifications"
				exact
				component={lateNotification}
			/>

			{/* Settings Menu end */}
			<Route path="/MyReimbursement" exact component={MyReimbursement} />
			<Route
				path="/monthlyReimbursement"
				exact
				component={MonthlyReimbursement}
			/>
			<Route
				path="/monthlyReimbursement/:id"
				exact
				component={MonthlyReimbursement}
			/>
			<Route
				path="/generalReimbursement"
				exact
				component={CreateGeneralReimbursement}
			/>

			<Route
				path="/ItemRequisition"
				exact
				component={ItemRequisitionLayout}
			/>
			<Route
				path="/SpTimeSheetStatus"
				exact
				component={SpTimesheetStatus}
			/>
			<Route
				path="/SpTimeSheetStatus/:value"
				exact
				component={SpTimesheetStatus}
			/>
			<Route
				path="/SpTimeSheetStatus/:value"
				exact
				component={SpTimesheetStatus}
			/>
			<Route
				path="/ResourceProjectHours"
				exact
				component={ResourceProjectHours}
			/>
			<Route
				path="/totalProjectHours"
				exact
				component={TotalProjectHours}
			/>
			<Route
				path="/ItemRequisitionDetail/:id"
				exact
				component={CreateItemRequisitionLayout}
			/>
			<Route
				path="/CreateItemRequisition"
				exact
				component={CreateItemRequisitionLayout}
			/>

			<Route
				path="/MyTimeSheetStatus"
				exact
				component={MyTimeSheetsStatusView}
			/>
			<Route
				path="/MyTimeSheetStatus/:id"
				exact
				component={MyTimeSheetsStatusView}
			/>

			<Route
				path="/ResourceLeavesInfo"
				exact
				component={ResourceLeavesInfo}
			/>
			<Route
				path="/ResourceLeavesInfo/:id"
				exact
				component={ResourceLeavesInfo}
			/>
			<Route
				path="/EmployeeLeavesListing"
				exact
				component={EmployeeLeaveInfoListing}
			/>
			<Route
				path="/spResourceLeavesInfo/:id"
				exact
				component={SpResourceLeavesInfo}
			/>
			<Route
				path="/TimesheetPerformanceReport"
				exact
				component={TimesheetPerformanceReport}
			/>
			<Route
				path="/EmployeesMonthlyLeaves"
				exact
				component={EmployeesMonthlyLeaves}
			/>

			<Route path="/CheckInCheckOut" exact component={CheckInCheckOut} />
			<Route
				path="/CheckInCheckOut/:id"
				exact
				component={CheckInCheckOut}
			/>

			<Route
				path="/resourceDailyHours"
				exact
				component={ResourceDailyHours}
			/>
			<Route path="/SpTimesheet" exact component={SpTimesheet} />
			<Route path="/SpTimesheet/:week" component={SpTimesheet} />

			<Route
				path="/SpMonthlyTimesheet"
				exact
				component={SpMonthlyTimesheet}
			/>

			<Route path="/WeeklyView" exact render={(props) => <WeeklyView {...props} userDetails={userDetails} />} />
			<Route path="/WeeklyView/:week" exact render={(props) => <WeeklyView {...props} userDetails={userDetails} />} />

			<Route
				path="/CMAssignedTickets"
				exact
				component={CMAssignedTickets}
			/>
			<Route
				path="/CountryManagerTicketListing"
				exact
				component={CountryManagerTicketListing}
			/>
			<Route
				path="/DepartmentTicketListing"
				exact
				component={DepartmentTicketListing}
			/>
			<Route
				path="/EditTicketByResource/:ticketId"
				exact
				component={EditTicketByResource}
			/>
			<Route
				path="/DeptTicketApproval/:ticketId"
				exact
				component={DeptTicketApproval}
			/>
			<Route
				path="/TicketHistory/:projectId"
				exact
				component={TicketHistory}
			/>

			<Route
				path="/CMTicketApproval/:ticketId"
				exact
				component={CMTicketApproval}
			/>
			<Route path="/ProjectListing" exact component={ProjectListing} />
			<Route
				path="/ProjectHistory/:projectId"
				exact
				component={ProjectHistory}
			/>
			<Route path="/CreateProject" exact component={CreateProject} />
			<Route
				path="/UpdateProject/:projectId"
				exact
				component={UpdateProject}
			/>
			<Route
				path="/TicketDetails/:ticketId"
				exact
				component={TicketDetails}
			/>
			<Route
				path="/ProjectDetails/:projectId"
				exact
				component={ProjectDetails}
			/>
			<Route path="/MyTickets" exact component={MyTickets} />
			<Route path="/Ticket" exact component={Ticket} />
			<Route path="/SpDashboard" exact component={SpDashboard} />
			<Route path="/MyDashboard" exact component={MyDashboard} />
			<Route path="/CMDashboard" exact component={CMDashboard} />
			<Route path="/" exact render={(props) => <MyDashboard {...props} userDetails={userDetails} />} />
			<Route path="/signin" exact component={SignIn} />
			<Route path="/Bug" exact component={FeedbackView} />
			<Route path="/ReportedBugs" exact component={FeedbackList} />
			<Route path="/adminRole/ManageDesignation" exact component={Designation} />
			<Route path="/editBug/:feedbackId" exact component={EditFeedback} />
			<Route
				path="/feedbackDetails/:feedbackId"
				exact
				component={FeedbackDetails}
			/>
			<Route
				path="/feedbackStatusDetails/:feedbackId"
				exact
				component={FeedbackDetails}
			/>
			<Route path="/teamDetails/:id" exact component={ManageLeaves} />
			<Route
				path="/feedbackDetails/:feedbackId"
				exact
				component={FeedbackDetails}
			/>
			<Route
				path="/feedbackStatusDetails/:feedbackId"
				exact
				component={FeedbackDetails}
			/>
			<Route
				path="/SpReviewLeave"
				exact
				component={ReviewLeaveApplication}
			/>
			<Route
				path="/SpReviewLeave/:id"
				exact
				component={ReviewLeaveApplicationDetail}
			/>

			<Route
				path="/SpReviewedLeave"
				exact
				component={ReviewedLeaveApplication}
			/>
			<Route
				path="/SpReviewedLeave/:id"
				exact
				component={ReviewedLeaveApplicationDetail}
			/>
			<Route
				path="/SpOffsiteWorkHours"
				exact
				component={SpOffsiteWorkHours}
			/>
			<Route
				path="/SpManageOffsiteWorkRequest/:id"
				exact
				component={ManageOffsiteWorkRequest}
			/>
			<Route
				path="/ReviewItemRequsition"
				exact
				component={ReviewItemRequsition}
			/>
			<Route
				path="/ReviewItemRequisitionDetail/:id"
				exact
				component={ReviewItemRequisitionDetail}
			/>
			<Route
				path="/ItemRequisitionClasses"
				exact
				component={ItemRequisitionClasses}
			/>
			<Route
				path="/ItemRequisitionVendors"
				exact
				component={ItemRequisitionVendors}
			/>
			<Route
				path="/MonthlyTimeSheetsConfig"
				exact
				component={MonthlyConfigForm}
			/>
			<Route path="/CreateNewVendor" exact component={CreateNewVendor} />
			<Route
				path="/CreateNewVendor/:vendorId"
				exact
				component={CreateNewVendor}
			/>

			<Route
				path="/ItemRequisitionCategories"
				exact
				component={ItemRequisitionCategories}
			/>
			<Route path="/ViewEmployees" exact component={viewEmployees} />
			<Route
				path="/ModifyEmployee/:id"
				exact
				component={ModifyEmployee}
			/>
			<Route
				path={"/VendorCategories/:vendorId"}
				exact
				component={VendorCategories}
			/>
			<Route
				path={"/VendorContact/:vendorId"}
				exact
				component={VendorContact}
			/>

			<Route path="/ProjectReport" exact component={ProjectReport} />

			{/*---------SSN--------------*/}
			<Route
				path="/SSNCreateItemRequisition"
				exact
				component={SSNCreateItemRequisition}
			/>
			<Route
				path="/SSNItemRequisitionDetail/:id"
				exact
				component={SSNItemRequisitionDetail}
			/>

			{/*---------Admin--------------*/}

			<Route
				path="/adminRole/CompensationLog"
				exact
				component={CompensationLog}
			/>
			<Route
				path="/adminRole/CompensationLogDetail/:id"
				exact
				component={CompensationLogDetail}
			/>

			{/*---------Admin--------------*/}

			<Route
				path="/adminRole/EmployeeWorkStatus"
				exact
				component={EmployeeWorkStatus}
			/>
			<Route
				path="/adminRole/AddEmployeeWorkStatusForm"
				exact
				component={AddEmployeeWorkStatusForm}
			/>

			<Route
				path="/AdminCalendarHolidays"
				exact
				component={AdminCalendarHolidays}
			/>
			<Route path="/AddNewHoliday" exact component={AddNewHoliday} />
			<Route path="/AddNewHoliday/:id" exact component={AddNewHoliday} />
			<Route
				path="/ReimbursementPolicy"
				exact
				component={ReimbursementPolicy}
			/>
			<Route
				path="/ReimbursementPolicyUpload"
				exact
				component={ReimbursementPolicyUpload}
			/>
			
			<Route
				path="/AdminViewResourceLeavesInfo/:id"
				exact
				component={AdminViewResourceLeavesInfo}
			/>

			<Route path="/tossLive/:text" exact component={IFrameFile} />
			<Redirect from="*" to="/MyDashboard" />
		</Switch>
	)
}

export default Routes
